"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullTabbyAdapter = void 0;
exports.NullTabbyAdapter = {
    log: () => { },
    injectContext: l => l,
    getTraceContextFromMetadata: () => null,
};
//# sourceMappingURL=null_adapter.js.map